import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../shared";
import { AppletNotificationSubscriptionHdrModel } from "../../../../../models/aggregates/applet/applet_notification_subscription_hdr.model";

@Injectable({providedIn: 'root'})
export class AppletNotificationSubscriptionHdrService extends BaseApiTemplateService<AppletNotificationSubscriptionHdrModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl =
        Core2Config.DOMAIN_URL +
        Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 
        'applet/applet-notification-subscriptions';
    this.httpClient = http;
    this.endpoint_path =  Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 
    'applet/applet-notification-subscriptions';
    }
}
